import { useIsFocused, useNavigation, usePreventRemove } from "@react-navigation/native";
import { useSetAlert } from "./use-set-alert";
import { RootStackParamList } from "../navigations/RootNavigation";
import { StackScreenProps } from "@react-navigation/stack";
import { useI18n } from "./i18n-hooks";
import { useMemo } from "react";

type ScreenParams = StackScreenProps<RootStackParamList>;

type UsePreventGoingBackParams = {
    prevent?: boolean;
    warning?: boolean;
    title?: string;
    message?: string;
    quitText?: string;
};

/*
 ** This hook prevent any back navigation, including GO_BACK, RESET, POP_TO, and probably others
 */
export const usePreventGoingBack = (params?: UsePreventGoingBackParams) => {
    const i18n = useI18n();
    const { setAlert } = useSetAlert();
    const navigator = useNavigation<ScreenParams["navigation"]>();

    const {
        prevent = true,
        warning = true,
        title,
        message,
        quitText,
    } = useMemo(() => params || {}, [params]);

    // Is screen currently focused
    const isFocused = useIsFocused();

    usePreventRemove(prevent && isFocused, ({ data }) => {
        if (warning) {
            setAlert({
                title: title || i18n.t("prevent_going_back.go_back"),
                message: message || i18n.t("prevent_going_back.informations_might_not_be_saved"),
                buttons: [
                    {
                        text: quitText || i18n.t("prevent_going_back.quit"),
                        onPress: () => navigator.dispatch(data.action),
                        style: "destructive",
                    },
                    {
                        text: i18n.t("cancel"),
                        style: "cancel",
                    },
                ],
            });
        }
    });
};
